import { Currency, ProductCategory, ProductStockStatus, ProductType } from '../../constants';

type ProductBase = {
  productId: number;
  sku: string;
  name: string;
  brand: string;
  productLink: string;
  productImageUrls: string[];
  category: ProductCategory[];
  modifiedAt: string;
  currency: Currency;
  status: ProductStockStatus;
  size: string;
  pack: string;
  score?: number;
};

export type ProductInfo = ProductBase & {
  originalPrice: number;
  salePrice?: number;
};

export type SimpleProduct = ProductInfo & {
  type: ProductType.Simple;
};

export type VariationProduct = ProductInfo & {
  type: ProductType.Variation;
};

type VariableProduct = ProductBase & {
  type: ProductType.Variable;
  variations: VariationProduct[];
};

export type Product = SimpleProduct | VariableProduct;
